/**
 * Shared property-type / deal-type / sort vocabulary for owner and public
 * profile catalogues. Presentation constants + pure mapping only — no fetch.
 */

export const PROFILE_PROPERTY_TYPES = [
  { value: "apartment", label: "Квартира", icon: "fa-solid fa-building" },
  { value: "house", label: "Будинок", icon: "fa-solid fa-house" },
  { value: "land", label: "Земельна ділянка", icon: "fa-solid fa-mountain-sun" },
  { value: "commercial", label: "Комерція", icon: "fa-solid fa-store" },
  { value: "industrial", label: "Промислова", icon: "fa-solid fa-industry" },
];

export const PROFILE_DEAL_TYPES = [
  { value: "", label: "Усі" },
  { value: "sale", label: "Продаж" },
  { value: "rent", label: "Оренда" },
];

export const PROFILE_SORT_OPTIONS = [
  {
    value: "date_desc",
    label: "За датою: спочатку нові",
    ordering: "-created_at",
  },
  {
    value: "date_asc",
    label: "За датою: спочатку старі",
    ordering: "created_at",
  },
  {
    value: "price_asc",
    label: "За ціною: від нижчої",
    ordering: "price",
  },
  {
    value: "price_desc",
    label: "За ціною: від вищої",
    ordering: "-price",
  },
];

export const PROFILE_DEFAULT_SORT = "date_desc";
export const PROFILE_DEFAULT_DEAL_TYPE = "";

const SORT_BY_VALUE = new Map(
  PROFILE_SORT_OPTIONS.map((opt) => [opt.value, opt]),
);

/**
 * Normalize profile sort tokens. Legacy `date` / `price` and any unknown
 * value safely collapse to newest-first (`date_desc`).
 */
export function normalizeProfileSort(sort) {
  if (SORT_BY_VALUE.has(sort)) return sort;
  return PROFILE_DEFAULT_SORT;
}

export function orderingFromProfileSort(sort) {
  const normalized = normalizeProfileSort(sort);
  return SORT_BY_VALUE.get(normalized).ordering;
}

/**
 * Normalize deal-type radio value. Only `sale` / `rent` are filterable;
 * everything else means "All" (omit `deal_type` from the request).
 */
export function normalizeProfileDealType(dealType) {
  if (dealType === "sale" || dealType === "rent") return dealType;
  return PROFILE_DEFAULT_DEAL_TYPE;
}
